import { Button } from 'antd';
import styled from 'styled-components';

import { FilterIcon } from '@assets/icons/FilterIcon';
import { UseModalVisibilityHookReturn } from '@hooks/shared/useModalVisibility';

import { JobsBoardFiltersModal } from './JobsBoardFiltersModal';

type JobsBoardFiltersProps = {
  totalJobsCount: number;
  filtersCount: number;
  jobsFiltersModalVisibility: UseModalVisibilityHookReturn;
};
export const JobsBoardFilters = ({
  totalJobsCount,
  filtersCount,
  jobsFiltersModalVisibility,
}: JobsBoardFiltersProps) => {
  return (
    <>
      <StyledContainer>
        <StyledButton onClick={jobsFiltersModalVisibility.showModal}>
          <div className='icon-container'>
            <FilterIcon />
          </div>
          <span>Filters</span>
          {!!filtersCount && (
            <span className='filters-count'>{filtersCount}</span>
          )}
        </StyledButton>
        <div className='jobs-count'>
          {Number.isFinite(totalJobsCount) ? `${totalJobsCount} Listings` : '-'}
        </div>
      </StyledContainer>
      <JobsBoardFiltersModal
        jobsFiltersModalVisibility={jobsFiltersModalVisibility}
      />
    </>
  );
};

const StyledContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: space-between;
    gap: 8px;
  }

  .jobs-count {
    color: ${({ theme }) => theme.palette.stroke[2]};
    font-size: 14px;
    line-height: 20px;
  }
`;

const StyledButton = styled(Button)`
  &.ant-btn {
    background-color: #ffffff;
    padding: 5px 11px 5px 7px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.palette.text[0]};
    line-height: 16px;
    border-color: ${({ theme }) => theme.palette.stroke[0]};
    font-weight: 600;
    font-size: 12px;

    &.ant-btn-default {
      box-shadow: none;
    }

    @media (max-width: 768px) {
      padding: 7px 15px 7px 11px;
      height: 40px;
      font-size: 14px;
      line-height: 20px;
    }

    .filters-count {
      font-size: 12px;
      line-height: 16px;
      color: #fff;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.palette.primary[0]};
    }
  }

  .icon-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;

    @media (max-width: 768px) {
      width: 24px;
      height: 24px;

      svg {
        width: 20px;
        height: 18px;
      }
    }
  }
`;
